import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../../common/inputs/common/SelectInput';
import i18n from '../../../i18n';
import { TIME_TYPE } from './attributionConstants';

function TimeTypeSelect({ onChange, value, ...props }) {
    const options = useMemo(
        () =>
            Object.keys(TIME_TYPE).map(item => ({
                label: i18n.t(`attributions.constants.${item}`),
                value: item
            })),
        []
    );

    return (
        <SelectInput
            {...props}
            onChange={onChange}
            value={value}
            options={options}
        />
    );
}

TimeTypeSelect.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default React.memo(TimeTypeSelect);
